import { h, render } from 'preact';
import '../../controls/ThumbnailTextOverlayControl/ThumbnailTextOverlayControl.js';
import { countMetric } from 'utilities/simpleMetrics.js';
import { Wistia } from '../../../../../../../wistia_namespace.ts';

countMetric('legacy/thumbnailTextOverlay.js', 1, {
  href: window.location.href,
});

class ThumbnailTextOverlayPlugin extends Wistia.Plugin.Base {
  constructor(video, options) {
    super(video, options);
    this.video = video;
    this.options = options;
    this._text = this.options.text || '';
    this._isEnabled = options.on !== false;
    if (this._isEnabled) {
      this.enable();
    } else {
      this.disable();
    }
  }

  enable() {
    this._isEnabled = true;
    return this.video.setControlEnabled('thumbnailTextOverlay', true);
  }

  disable() {
    this._isEnabled = false;
    const thumbnailControl = this.video.controls.thumbnail;
    if (thumbnailControl) {
      thumbnailControl.thumbnailAssets = this.video.thumbnailAssets();
      thumbnailControl.renderThumbnail();
    }
    return this.video.setControlEnabled('thumbnailTextOverlay', false);
  }

  updateFromOptions(options = {}) {
    if (this._isEnabled && !options.on) {
      this.disable();
    } else if (!this._isEnabled && options.on !== false) {
      this.enable();
    }
    this._text = options.text || '';
    this.video.whenControlMounted('thumbnailTextOverlay').then((control) => {
      if (!control.__destroyed) {
        control.renderThumbnailTextOverlay();
      }
    });
  }

  getText() {
    return this._text;
  }

  customizePreview(changeSet) {
    if (!(changeSet.changed('plugin[thumbnailTextOverlay]') || changeSet.changed('stillUrl'))) {
      return;
    }
    const thumbnailTextOverlayOptions = changeSet.currentValue('plugin[thumbnailTextOverlay]') || {
      on: false,
    };
    if (thumbnailTextOverlayOptions.on === false) {
      return;
    }
    if (this.video.controls.thumbnail && this.video.controls.thumbnail.__destroyed) {
      return;
    }
    // If the thumbnail control is enabled while we're previewing the text
    // overlay, we want that thumbnail to _not_ have any burned-in text, so we
    // stub the thumbnail assets to be just a textless (aka unaltered) asset.
    this.video.whenControlMounted('thumbnail').then((control) => {
      if (!control.__destroyed) {
        if (this.video._opts.unalteredStillImageAsset) {
          control.thumbnailAssets = [this.video._opts.unalteredStillImageAsset];
        }
        control.renderThumbnail();
      }
    });
    this.updateFromOptions(thumbnailTextOverlayOptions);
  }

  remove() {
    this.disable();
  }
}

Wistia.plugin('thumbnailTextOverlay', (video, options) => {
  return new ThumbnailTextOverlayPlugin(video, options);
});
